// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1OsGT","text":"SelectPayment_text__2AGqg","title":"SelectPayment_title__22GxC","btn":"SelectPayment_btn__GHwUH"};